module.exports = __webpack_public_path__ + "img/js6.dd71a02d.png";